import React from "react";
import { GoogleLogin } from "react-google-login";
import { useHistory } from "react-router";
import { LIWAT_GOOGLE_CLIENT_ID } from "../constants";
import { useAlert } from "react-alert";
import { post } from "../../common/api";
import { useDispatch } from "react-redux";
import { loadUser } from "../../actions/auth";

export function GoogleSignInButton(props) {
  const history = useHistory();
  const [isLoading, setIsLoading] = React.useState(false);
  const alert = useAlert();
  const dispatch = useDispatch();
  const onSuccess = async (googleResp) => {
    console.log("onSuccess: ", googleResp);
    const id_token = googleResp.getAuthResponse().id_token;
    console.log("id_token: ", id_token);
    setIsLoading(true);
    try {
      const res = await post("/api/auth/sign-in-with-google", {
        google_id_token: id_token,
      });
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: res.data,
      });
      history.push("/");
      dispatch(loadUser());
      alert.success("Success sign in with google");
    } catch (e) {
      console.log(e);
      alert.error(`${e}: ${JSON.stringify(e.response?.data)}`);
    }
    setIsLoading(false);
  };

  const onFailure = (googleResp) => {
    console.log(`onFailed: ${JSON.stringify(googleResp)}`);
    alert.error("Something went wrong with Google Sign In");
  };
  return (
    <GoogleLogin
      onSuccess={onSuccess}
      onFailure={onFailure}
      clientId={LIWAT_GOOGLE_CLIENT_ID}
      buttonText={isLoading ? "Loading" : "Masuk dengan Google"}
      disabled={isLoading}
      cookiePolicy={"single_host_origin"}
    />
  );
}
